import { render, staticRenderFns } from "./GoodCategory.vue?vue&type=template&id=babf3c90&scoped=true&"
import script from "./GoodCategory.vue?vue&type=script&lang=ts&"
export * from "./GoodCategory.vue?vue&type=script&lang=ts&"
import style0 from "./GoodCategory.vue?vue&type=style&index=0&id=babf3c90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "babf3c90",
  null
  
)

export default component.exports